import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledGroupMemberDetails = styled.div`
  padding: 0 16px;
  background-color: ${th('colors.confetti+4')};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
`;

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;

  :not(:first-child) {
    border-top: 1px solid ${th('colors.confetti')};
  }

  > :last-child {
    font-weight: 500;
  }
`;
